var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-10"},[_c('TimeFramesMenu'),_c('div',{staticStyle:{"background-color":"white","color":"black","height":"500px","min-height":"500px","margin-top":"15px"},attrs:{"id":"chart"}},[_c('apexchart',{ref:"chart",attrs:{"type":"line","height":"500px","options":_vm.chartOptions,"series":_vm.chart_data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }